import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { TouchableOpacity, ViewStyle } from 'react-native';

import { useTheme } from '@/components/theme-provider';
import type { IconName } from '@/types/icons';

export interface IconButtonProps {
	icon: IconName | string;
	onPress?: () => void;
	disabled?: boolean;
	size?: number;
	style?: ViewStyle;
	iconColor?: string;
	backgroundColor?: string;
	accessibilityLabel?: string;
	testID?: string;
}

export const IconButton: React.FC<IconButtonProps> = ({
	icon,
	onPress,
	disabled = false,
	size = 24,
	style,
	iconColor,
	backgroundColor,
	accessibilityLabel,
	testID,
}) => {
	const theme = useTheme();

	const buttonStyle: ViewStyle = {
		width: size + 16,
		height: size + 16,
		borderRadius: (size + 16) / 2,
		backgroundColor: backgroundColor || 'transparent',
		justifyContent: 'center',
		alignItems: 'center',
		opacity: disabled ? 0.5 : 1,
	};

	return (
		<TouchableOpacity
			style={[buttonStyle, style]}
			onPress={onPress}
			disabled={disabled}
			activeOpacity={0.7}
			accessibilityRole="button"
			accessibilityLabel={accessibilityLabel || icon.replace(/-/g, ' ').replace(/outline$/, '').trim()}
			accessibilityState={{ disabled }}
			testID={testID}
		>
			<Ionicons
				name={icon as IconName}
				size={size}
				color={iconColor || theme.colors.onSurface}
			/>
		</TouchableOpacity>
	);
};
